<button class="button is-primary is-outlined" on:click="set({active: true})"><i class="fas fa-magic"></i></button>

<div class="modal {active ? 'is-active': ''}">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Fill lineups?</p>
            <button class="delete" aria-label="close" on:click="closeDialog()"></button>
        </header>
        <section class="modal-card-body">
            By clicking Yes, all empty lineup positions will be filled
            {#if $useDepthChartToFill}
                using the depth chart.
            {:else}
                using available players.
            {/if}
            <br/>
            Continue?
        </section>
        <footer class="modal-card-foot">
            <button class="button is-primary" on:click='fillLineups()'>Yes</button>
            <button class="button " on:click='closeDialog()'>No</button>
        </footer>
    </div>
</div>

<script>
    export default {
        data() {
            return {
                active: false,
            }
        },
        methods: {
            fillLineups() {
                const fillOrder=[1,2,6,4,8,3,5,7,9,10];
                let {lineups, depthChart, useDepthChartToFill, activeRoster} = this.store.get();
                lineups.forEach((lineup) => {
                    fillOrder.forEach((pos) => {
                        if(lineup[pos] && !lineup[pos].number) {
                            const chart = depthChart[pos];
                            if(chart && useDepthChartToFill) {
                                const available = chart.filter((player) => {
                                    let isAvailable = true;
                                    Object.keys(lineup).forEach((key) => {
                                        const usedPlayer = lineup[key];
                                        if(usedPlayer.first == player.first && usedPlayer.last == player.last) {
                                            isAvailable = false;
                                        }
                                    });
                                    let isActive = false;
                                    if(isAvailable) {
                                        activeRoster.forEach((activePlayer) => {
                                            if(player.first == activePlayer.first && player.last == activePlayer.last) {
                                                isActive = true;
                                            }
                                        });
                                    }
                                    return isAvailable && isActive;
                                });
                                if(available.length > 0) {
                                    lineup[pos] = available[0];
                                } else {

                                }
                            } else {

                            }
                        }
                    });
                });
                
                this.store.set({lineups});
                this.set({active: false});
            },
            closeDialog() {
                this.set({active: false});
            }
        }
    };
</script>
